
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5496',
  depVersions: {
  "data-privacy-request-ui": "static-1.5496",
  "data-fetching-client": "static-1.9640",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7982",
  "hub-http-shared-msw-handlers": "static-1.9878",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11431",
  "I18n": "static-7.1615",
  "jasmine-runner": "static-1.6435",
  "privacy-center-public-service-types": "static-1.4759",
  "quartz": "static-1.6978",
  "react-dlb": "static-1.78",
  "ui-components-test-utils": "static-1.5569",
  "UIComponents": "static-3.8378",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.85",
  "foundations-assets": "static-1.4827",
  "foundations-components": "static-1.7861",
  "foundations-components-test-utils": "static-1.5344",
  "foundations-theming": "static-1.4384",
  "hub-http": "static-1.6188",
  "quartz-config": "static-1.756",
  "quartz-core": "static-1.6197",
  "quartz-routing": "static-1.408",
  "quick-fetch": "static-1.3887",
  "raven": "static-3.5829",
  "react": "static-7.185",
  "react-rhumb": "static-1.16637",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11116",
  "usage-tracker": "static-1.7305",
  "usage-tracker-anonymous": "static-1.5722",
  "usage-tracker-core": "static-1.7155",
  "enviro": "static-4.428",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4049",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3375",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3255",
  "quartz-webpack": "static-1.3202",
  "bend-plugin-quartz-routing": "static-1.56",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.81",
  "HeadJS": "static-2.743",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3093",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "ts-schema": "static-1.4050",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "react-utils": "static-2.5316",
  "StyleGuideUI": "static-3.486",
  "jasmine": "static-4.4293",
  "rpc-client-utils": "static-1.4618",
  "HubStyle": "static-2.11739",
  "ui-addon-draggable": "static-3.4735",
  "cssUtils": "static-1.782",
  "hs-story-utils": "static-1.9395",
  "icons": "static-2.644",
  "react-select-plus": "static-1.104",
  "react-virtualized": "static-2.98",
  "ui-images": "static-2.1143",
  "bend-plugin-foundations-components": "static-1.4130",
  "floating-ui": "static-1.55",
  "foundations-theming-specialty": "static-1.2100",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.13",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1757",
  "ui-fonts": "static-1.693",
  "foundations-components-legacy": "static-1.886",
  "bend-plugin-foundations-theming": "static-1.2867",
  "foundations-theming-base": "static-1.3369",
  "stylex": "static-1.32",
  "hs-locale-management": "static-1.56",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.828",
  "hubspotter-http": "static-1.4623",
  "mobile-manifest-mixins": "static-1.517",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.653",
  "quartz-head": "static-1.643",
  "quartz-i18n": "static-1.653",
  "quartz-test": "static-1.653",
  "quartz-tracking": "static-1.357",
  "usage-tracker-container": "static-1.7295",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "csstype": "static-1.50",
  "web-vitals": "static-1.4",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3160",
  "bend-plugin-chirp-manifest": "static-1.28",
  "chirp-fetch": "static-1.1853",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.69",
  "sassPrefix": "static-1.155",
  "hubspotter-http-shared-msw-handlers": "static-1.9876",
  "usage-tracker-session-replay": "static-1.4991",
  "amplitude-session-replay-browser": "static-1.59"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5496",
  "data-fetching-client": "/data-fetching-client/static-1.9640",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7982",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9878",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11431",
  "I18n": "/I18n/static-7.1615",
  "jasmine-runner": "/jasmine-runner/static-1.6435",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4759",
  "quartz": "/quartz/static-1.6978",
  "react-dlb": "/react-dlb/static-1.78",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5569",
  "UIComponents": "/UIComponents/static-3.8378",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "foundations-assets": "/foundations-assets/static-1.4827",
  "foundations-components": "/foundations-components/static-1.7861",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5344",
  "foundations-theming": "/foundations-theming/static-1.4384",
  "hub-http": "/hub-http/static-1.6188",
  "quartz-config": "/quartz-config/static-1.756",
  "quartz-core": "/quartz-core/static-1.6197",
  "quartz-routing": "/quartz-routing/static-1.408",
  "quick-fetch": "/quick-fetch/static-1.3887",
  "raven": "/raven/static-3.5829",
  "react": "/react/static-7.185",
  "react-rhumb": "/react-rhumb/static-1.16637",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11116",
  "usage-tracker": "/usage-tracker/static-1.7305",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5722",
  "usage-tracker-core": "/usage-tracker-core/static-1.7155",
  "enviro": "/enviro/static-4.428",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3375",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3255",
  "quartz-webpack": "/quartz-webpack/static-1.3202",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.56",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.81",
  "HeadJS": "/HeadJS/static-2.743",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3093",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "ts-schema": "/ts-schema/static-1.4050",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "react-utils": "/react-utils/static-2.5316",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "jasmine": "/jasmine/static-4.4293",
  "rpc-client-utils": "/rpc-client-utils/static-1.4618",
  "HubStyle": "/HubStyle/static-2.11739",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4735",
  "cssUtils": "/cssUtils/static-1.782",
  "hs-story-utils": "/hs-story-utils/static-1.9395",
  "icons": "/icons/static-2.644",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-virtualized": "/react-virtualized/static-2.98",
  "ui-images": "/ui-images/static-2.1143",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4130",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2100",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.13",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1757",
  "ui-fonts": "/ui-fonts/static-1.693",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.886",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2867",
  "foundations-theming-base": "/foundations-theming-base/static-1.3369",
  "stylex": "/stylex/static-1.32",
  "hs-locale-management": "/hs-locale-management/static-1.56",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.828",
  "hubspotter-http": "/hubspotter-http/static-1.4623",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.517",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.653",
  "quartz-head": "/quartz-head/static-1.643",
  "quartz-i18n": "/quartz-i18n/static-1.653",
  "quartz-test": "/quartz-test/static-1.653",
  "quartz-tracking": "/quartz-tracking/static-1.357",
  "usage-tracker-container": "/usage-tracker-container/static-1.7295",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.4",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3160",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.28",
  "chirp-fetch": "/chirp-fetch/static-1.1853",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.69",
  "sassPrefix": "/sassPrefix/static-1.155",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9876",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4991",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59"
}
};
